import { useAtom } from "jotai";
import { authenticationAtom } from "../State";
import { resolveAccess } from "./roleAccessCore";

// Re-export everything from the core so callers don't need to change their imports.
export type { RoleAccess } from "./roleAccessCore";
export {
  getRoleAccess,
  hasRoleAssignment,
  isRootUser,
  isSystemAdminUser,
  resolveAccess,
  viewerMayExecuteHumanTask,
} from "./roleAccessCore";

/**
 * Central role-based access control for the frontend.
 *
 * This is the SINGLE SOURCE OF TRUTH for all role checks in the portal.
 * Do NOT duplicate hasRole / roleAssignment checks elsewhere.
 *
 * Role hierarchy (highest to lowest):
 *   1. System-Admin  (roles: "administrator" | "root")  -> full access
 *   2. customerAdministrator                              -> full customer access
 *   3. billingAdministrator                               -> billing, payments, orders (view)
 *   4. technicalAdministrator                             -> API keys, agents, statistics
 *   5. no role                                            -> profile, security only
 *
 * The customer record is pre-fetched in Protected.tsx before the authenticated
 * pages render and cached on the authentication atom as `customerObject`.
 * This hook simply reads it — no async work needed here.
 */
export const useRoleAccess = () => {
  const [authentication] = useAtom(authenticationAtom) as any;
  return resolveAccess(authentication, authentication?.customerObject ?? null);
};
